import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-md-vehicles',
  templateUrl: './md-vehicles.component.html',
  styleUrls: ['./md-vehicles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MdVehiclesComponent {

  vehicleDataChildren: Route[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Find the master-data route first
    const masterDataRoute = this.router.config.find(r => r.path === 'master-data');

    // Then find the 'other' child route within master-data
    const otherRoute = masterDataRoute?.children?.find(child => child.path === 'vehicles');

    // Get the third-level children (auction-hall, documents, etc.)
    this.vehicleDataChildren = otherRoute?.children ?? [];
  }
}
